import React from "react";

function YouTubeVideoPlayer({ videoLink }) {
  // Extract the video ID from the YouTube link
  const videoId = extractVideoId(videoLink);

  // Helper function to extract the video ID from a YouTube link
  function extractVideoId(url) {
    // Regular expression to match YouTube video URLs
    const regExp =
      /^(?:(?:https?:)?\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|v\/|embed\/|)([a-zA-Z0-9_-]+)/;
    const match = url.match(regExp);

    if (match && match[1]) {
      return match[1];
    } else {
      // Handle invalid YouTube URLs here
      return null;
    }
  }

  if (!videoId) {
    // Handle invalid YouTube URLs or missing videoLink in the database
    return <div>Invalid YouTube video link</div>;
  }

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="relative w-full aspect-video">
        <iframe
          title="YouTube Video"
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${videoId}`}
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          className="w-full h-full rounded-lg"
        ></iframe>
      </div>
    </div>
  );
}

export default YouTubeVideoPlayer;
